import type { ReactNode } from 'react';

export const symbol_wb_twilight: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M792-670q9 9 9 21t-9 21l-43 43q-9.07 9-21.53 9-12.47 0-21.34-9.05-9.13-9.06-8.63-21.5Q698-619 707-628l43-42q9-8 21-8.5t21 8.5ZM110-170q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-230 110-230h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Zm391.5-621.38q8.5 8.63 8.5 21.38v60q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-60q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62ZM169-672q9-9 21-9t21 9l44 44q9 9.07 9 21.53 0 12.47-9 21.86-9 8.61-21.5 8.11T212-586l-43-44q-8-9-8.5-21t8.5-21Zm99 292h424q-19-71-77-115.5T480-540q-77 0-135 44.5T268-380Zm-68 60q0-117 81.5-198.5T480-600q117 0 198.5 81.5T760-320H200Zm280-60Z"
		/>
	</svg>
);
